import { lazy } from 'react';
import { authRoles } from 'app/auth';
import { inventoryLookupLayout } from 'app/configs/settingsConfig';

const InventoryLookupPage = lazy(() => import('./InventoryLookupPage'));

/**
 * PGSS-5715: the one page an Inventory Lookup login can open. `auth` is exactly the lookup role, so
 * no other role reaches it, and the role reaches nothing else (it is not in settingsConfig.defaultAuth).
 */
const InventoryLookupConfig = {
  settings: {
    layout: {
      style: inventoryLookupLayout.style,
      config: inventoryLookupLayout.config,
    },
  },
  auth: authRoles.inventoryLookup,
  routes: [
    {
      path: 'inventory-lookup',
      element: <InventoryLookupPage />,
    },
  ],
};

export default InventoryLookupConfig;
